import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityFeatures = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'Bank-Level Security',
      description: 'Your financial data is protected with 256-bit encryption'
    },
    {
      icon: 'Lock',
      title: 'Secure Authentication',
      description: 'Multi-factor authentication keeps your account safe'
    },
    {
      icon: 'Eye',
      title: 'Privacy First',
      description: 'We never share your personal information with third parties'
    },
    {
      icon: 'FileCheck',
      title: 'Compliance Ready',
      description: 'Fully compliant with financial data protection regulations'
    }
  ];

  return (
    <div className="mt-32 pt-32 border-t border-border">
      <h3 className="text-lg font-heading font-semibold text-card-foreground mb-20 text-center">
        Your Security is Our Priority
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
        {securityFeatures?.map((feature, index) => (
          <div 
            key={index}
            className="flex items-start space-x-12 p-12 rounded-lg bg-muted/50 hover:bg-muted transition-smooth"
          >
            <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon 
                name={feature?.icon} 
                size={20} 
                color="var(--color-primary)"
                strokeWidth={2}
              />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-caption font-semibold text-card-foreground mb-4">
                {feature?.title}
              </h4>
              <p className="text-xs text-muted-foreground line-clamp-2">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-20 p-16 bg-primary/5 rounded-lg border border-primary/20">
        <div className="flex items-start space-x-12">
          <Icon 
            name="Info" 
            size={20} 
            color="var(--color-primary)"
            className="flex-shrink-0 mt-2"
          />
          <p className="text-sm text-muted-foreground">
            By creating an account, you're joining thousands of users who trust Rovyn Budget 
            to manage their finances securely. Your data is encrypted both in transit and at rest.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SecurityFeatures;